export default __webpack_public_path__ + "static/media/193.e9750bdf.jpg";